export default "__VITE_ASSET__DgxIrnIG__"